import React from "react";
import styled from "styled-components";
import IconSAT from '../../assets/images/icon-sat.svg'

const Container = styled.div`
    width: 100vw;
    height: 100vh;
    background-color: #FFFFFF;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 999;

    .box {
        width: 100%;
        height: 100%;
        background: linear-gradient(153.06deg, rgba(246, 210, 133, 0.3) -0.31%, rgba(187, 240, 243, 0.3) 99.69%);
    }

    .icon {
        width: 100px;
    }
`;

function LandingPage() {
    return (
        <Container>
            <div className="content-center box">
                <img alt="img" className="icon" src={IconSAT} />
            </div>
        </Container>
    )
}

export default LandingPage;